export default __webpack_public_path__ + "static/media/FormInteraction.8ff014e2.png";